'use es6';

import { Record } from 'immutable';
export default Record({
  error: null,
  fingerprint: null,
  extra: {},
  tags: {}
}, 'SentryContext');